import React from 'react';

import { useTwoFactor } from '../../hooks/useTwoFactor';

import { PhoneSetupStep } from './PhoneSetupStep';
import { ProviderSelectStep } from './ProviderSelectStep';
import { VerifyCodeStep } from './VerifyCodeStep';

export const TwoFactorView = () => {
    const twoFactor = useTwoFactor();

    if (twoFactor.step === 'phone-setup') {
        return (
            <PhoneSetupStep
                onComplete={twoFactor.onPhoneSetupComplete}
                onBack={twoFactor.backToProviderSelect}
            />
        );
    }

    if (twoFactor.step === 'verify-code') {
        return (
            <VerifyCodeStep
                selectedProvider={twoFactor.selectedProvider}
                rememberBrowser={twoFactor.rememberBrowser}
                isVerifying={twoFactor.isVerifyingCode}
                error={twoFactor.verifyCodeError}
                onVerify={twoFactor.verifyCode}
                onRememberBrowserChange={twoFactor.setRememberBrowser}
                onBack={twoFactor.backToProviderSelect}
            />
        );
    }

    // step === 'provider-select'
    return (
        <ProviderSelectStep
            providers={twoFactor.providers}
            selectedProvider={twoFactor.selectedProvider}
            isLoading={twoFactor.isLoadingProviders}
            isSending={twoFactor.isSendingCode}
            error={twoFactor.sendCodeError}
            onSelect={twoFactor.selectProvider}
            onSendCode={twoFactor.sendCode}
            onPhoneSetup={twoFactor.goToPhoneSetup}
            onBack={twoFactor.backToLogin}
        />
    );
};
